import React from 'react';
import { Link } from 'react-router-dom';
import ServiceCard from '../components/ServiceCard';
import PageHeader from '../components/PageHeader';

const Services = () => {
  const services = [
    {
      icon: '/images/SIDT.png',
      title: 'Strategic Innovation & Digital Transformation',
      description: 'Transform your business with the perfect blend of strategic vision and precise execution. Our unique model pairs US-based enterprise architects with specialized offshore engineering teams to deliver comprehensive IT support, AI automation, and cloud transformation solutions.',
      details: [
        {
          title: 'Digital Transformation & Innovation',
          items: [
            'Strategic digital roadmap development',
            'Legacy system modernization',
            'Digital workplace transformation',
            'Innovation strategy and implementation'
          ]
        },
        {
          title: 'Enterprise Architecture & Integration',
          items: [
            'Technology architecture design',
            'System integration planning',
            'API strategy and development',
            'Microservices architecture'
          ]
        }
      ]
    },
    {
      icon: '/images/AI.png',
      title: 'Intelligent Automation & AI Solutions',
      description: 'Leverage AI and automation to drive efficiency and business impact. Our cross-functional teams combine deep domain expertise with cutting-edge machine learning and intelligent process automation capabilities.',
      details: [
        {
          title: 'AI & Machine Learning Solutions',
          items: [
            'Custom AI model development',
            'Predictive analytics implementation',
            'Natural language processing',
            'Computer vision solutions'
          ]
        },
        {
          title: 'Intelligent Process Automation',
          items: [
            'RPA implementation and optimization',
            'Workflow automation design',
            'Business process optimization',
            'Intelligent document processing'
          ]
        }
      ]
    },
    {
      icon: '/images/Data.png',
      title: 'Data & Analytics Excellence',
      description: 'Unlock the power of data-driven decision-making with our comprehensive analytics solutions. Our hybrid delivery model ensures you get both strategic insights and technical excellence.',
      details: [
        {
          title: 'Enterprise Data Strategy & Architecture',
          items: [
            'Data governance framework',
            'Data architecture design',
            'Master data management',
            'Data quality assessment'
          ]
        },
        {
          title: 'Advanced Analytics & Business Intelligence',
          items: [
            'Interactive dashboard development',
            'Real-time analytics implementation',
            'Advanced reporting solutions',
            'Data visualization expertise'
          ]
        }
      ]
    },
    {
      icon: '/images/Cloud.png',
      title: 'Cloud & Infrastructure Transformation',
      description: 'Modernize your technology foundation with confidence. Our hybrid teams deliver cloud solutions designed for scalability, security, and cost-effectiveness.',
      details: [
        {
          title: 'Cloud Migration & Modernization',
          items: [
            'Cloud strategy and planning',
            'Application migration services',
            'Infrastructure modernization',
            'Multi-cloud architecture'
          ]
        },
        {
          title: 'DevSecOps & Platform Engineering',
          items: [
            'CI/CD pipeline implementation',
            'Security automation',
            'Platform as a Service (PaaS)',
            'Infrastructure as Code (IaC)'
          ]
        }
      ]
    }
  ];

  return (
    <div>
      <PageHeader 
        title="SERVICES"
        subtitle="Empowering Businesses Through People, Process, and Technology"
        backgroundImage="/images/Servicesbg.png"
      />
      <div className="page-content">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                icon={service.icon}
                title={service.title}
                description={service.description}
                details={service.details}
              />
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <p style={{ marginBottom: '1rem' }}>Ready to get started?</p>
            <Link to="/contact" className="hero-btn">Get Started Today</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services; 